export const optionTypeList = [
  {
    label: "사이드메뉴 (필수)",
    value: 0,
  },
  {
    label: "음료",
    value: 1,
  },
  {
    label: "파채 옵션",
    value: 2,
  },
  {
    label: "김가루 옵션",
    value: 3,
  },
  {
    label: "사리 추가",
    value: 4,
  },
  {
    label: "듬뿍짜글이토핑 (필수)",
    value: 5,
  },
  {
    label: "맵기조절",
    value: 6,
  },
];
